<div class="card mt-15 px-20">
  <div class="row">
    <div class="col-md-12 col-lg-12 d-flex align-items-center s_between">
      <h1 class="user-title fs-18">Turn bookings on or off</h1>
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="21" fill="currentColor" class="bi bi-pencil-fill"
        viewBox="0 0 16 22">
        <path
          d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
      </svg>
    </div>
    <div class="col-md-12 col-lg-12">
      <div class="col-md-12 col-sm-12">
        <p class="txt-regular fs-16">
          Toggle on to be available for casual bookings. Toggle off to hide your
          profile and stop new booking requests.
        </p>
      </div>
      <div class="col-md-12 col-lg-12">
        <div class="job__alerts d-flex mt-10">
          <div class="mr-10">
            <div class="form-check form-switch mt-4">
              <input type="checkbox" role="switch" id="availability-switch-1"
                class="form-check-input delay-send form__switch_cc c-p" [(ngModel)]="availabilitySwitch1"
                name="availabilitySwitch1" />
            </div>
          </div>
          <p class="txt-regular">
            When your availability is on, your profile is visible to schools.
            School’s can find and book you, you can also apply for job
            opportunities through ClassCover Jobs and you also have access to
            ClassCover’s online library of professional development
          </p>
        </div>
      </div>
    </div>
  </div>
</div>